<template>
    <el-drawer class="w-el-drawer" :visible.sync="visible" size="100%" :with-header="false" direction="ltr" :before-close="Close" append-to-body>
        <div class="w-el-drawer-header">
            <i class="el-icon-tickets"></i> 项目模板
        </div>
        <div class="w-el-drawer-body" v-loading.lock="loading" :element-loading-text="loadingText">
            <vxe-table
                ref="xTable"
                :data="task"
                border="inner"
                row-key
                show-overflow
                :cell-style="CellFormValidator"
                :row-config="{isCurrent: true, isHover: true}"
                :column-config="{isCurrent: true, isHover: true}"
                :scroll-y="{enabled: false}"
                :tree-config="{transform: true, childrenField: 'children', rowField: 'rowId', parentField: 'parentField', indent: 10, reserve: true, expandAll: true}">
                <vxe-column type="seq" width="100" fixed="left" align="left" tree-node></vxe-column>
                <vxe-column type="checkbox" width="45" fixed="left"></vxe-column>
                <vxe-column min-width="200" field="name"> 
                    <template #header>
                        <span style="color: red;">* </span>任务名称
                    </template>
                    <template #default="{ row }">
                        <el-input v-model="row.name" size="mini" clearable >
                            <el-color-picker slot="prepend" v-model="row.name_color" show-alpha :predefine="color"></el-color-picker>
                        </el-input>
                    </template>
                </vxe-column>
                <vxe-column min-width="150">
                    <template #header>
                        <span style="color: red;">* </span>任务类型
                    </template>
                    <template #default="{ row }">
                        <projects-task-type-select v-model="row.type_id" />
                    </template>
                </vxe-column>
                <vxe-column min-width="165">
                    <template #header>
                        <span style="color: red;">* </span>重要程度 / 优先级
                    </template>
                    <template #default="{ row }">
                        <projects-task-select-p v-model="row.p" clearable filterable />
                    </template>
                </vxe-column>
                <vxe-column min-width="250">
                    <template #header>
                        <span style="color: red;">* </span>起止日期
                    </template>
                    <template #default="{ row }">
                        <el-date-picker v-model="row.start_date" :disabled="row.disabled" style="width: 100%;" size="mini" type="daterange" value-format="yyyy-MM-dd" unlink-panels :clearable="false" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                    </template>
                </vxe-column>
                <vxe-column min-width="180">
                    <template #header>
                        <span style="color: red;">* </span>预估工时/P
                    </template>
                    <template #default="{ row }">
                        <el-input-number v-model="row.working_days" size="mini" @change="WorkingTimeCount" :min="1" :disabled="row.disabled"></el-input-number>
                    </template>
                </vxe-column>
                <vxe-table-column align="left" fixed="right" width="140" title="操作">
                    <template #default="{ row, rowIndex }">
                        <el-button-group>
                            <el-link type="danger"  style="margin-left: 5px;" @click="TaskDel(row)">移除</el-link>
                            <el-link type="primary" style="margin-left: 5px;" @click="TaskInsert(row, rowIndex)">复制</el-link>
                            <el-link type="primary" style="margin-left: 5px;" @click="TaskInsertChildren(row, rowIndex)" v-if="!row.parentField">子任务</el-link>
                        </el-button-group>
                    </template>
                </vxe-table-column>
            </vxe-table>
        </div>
        <div class="w-el-drawer-footer">
            <el-button size="medium" type="danger" @click="TaskDel()">移除任务</el-button>
            <el-divider direction="vertical"></el-divider>
            <el-button-group>
                <el-button size="medium" type="primary" plain @click="WorkingTimeCount()">重计工时</el-button>
                <el-button size="medium" type="primary" plain @click="TaskInsert()">添加任务</el-button>
            </el-button-group>
            <el-divider direction="vertical"></el-divider>
            <el-button size="medium" type="primary"  @click="TemplateChange()" :loading="loading">保存模板</el-button>
            <el-button size="medium" @click="Close()">关闭窗口</el-button>
        </div>
    </el-drawer>
</template>
<script>
export default {
    data() {
        return {
                        color: [
                '#f44336', '#e91e63', '#9c27b0', '#673ab7', '#3f51b5', 
                '#2196f3', '#03a9f4', '#00bcd4', '#009688', '#4caf50', 
                '#8bc34a', '#cddc39', '#ffeb3b', '#ffc107', '#ff9800', 
                '#ff5722', '#795548', '#9e9e9e', '#607d8b', '#000000'
            ],
                        visible: false,
            loading: false,
            loadingText: null,
                        template_id: null,
            task: [],
            taskError: [],
            team: [],
            files: [],
        }
    },
    methods: {
        Open (template_id) {
            this.visible = true
            this.loading = true
            this.template_id = template_id
            this.$http.post('/9api/projects-template/task-search', { template_id: template_id }).then(rps => {
                this.task = rps.data 
                this.loading = false
            })
        },
        Close() {
            this.$refs.xTable.setAllCheckboxRow(true)
            this.$refs.xTable.removeCheckboxRow()
            this.loading = false
            this.visible = false
        },
        TaskInsert(row, rowIndex) {
            if (row) {
                this.$refs.xTable.insertAt({
                    name: row.name,
                    name_color: row.name_color,
                    p: row.p,
                    type_id: row.type_id,
                    start_date: row.start_date,
                    working_days: row.working_days,
                    describe: row.describe,
                    rowId: Date.now(),
                    parentField: row.parentField,
                    disabled: false
                }, rowIndex)
            } else {
                this.$refs.xTable.insertAt({
                    name: null,
                    name_color: '#5489EA',
                    p: 3,
                    type_id: null,
                    start_date: [new Date(), new Date()],
                    working_days: 1,
                    describe: null,
                    rowId: Date.now(),
                    parentField: null,
                    disabled: false
                }, -1)
            }
                        this.WorkingTimeCount()
        },
        TaskInsertChildren(row, rowIndex) {
            if (!row.parentField) {
                this.$refs.xTable.insertAt({
                    name: null,
                    name_color: '#5489EA',
                    p: 3,
                    type_id: null,
                    start_date: row.start_date,
                    working_days: 1,
                    describe: null,
                    rowId: Date.now(),
                    parentField: row.rowId,
                    disabled: false
                }, -1)
                this.$refs.xTable.toggleTreeExpand([row], true)
                                this.WorkingTimeCount()
            }
        },
        WorkingTimeCount() {
                        let data = this.$refs.xTable.getTableData().tableData.filter(item => !item.parentField)
                        data.forEach(item => {
                                if (item.children  && item.children.length > 0) {
                    item.working_days = 0
                    item.disabled = true
                                        item.children.forEach((element, idx) => {
                        item.working_days += parseInt(element.working_days)
                        if (idx == 0) {
                            item.start_date = [element.start_date[0], element.start_date[1]]
                        } else {
                            if (item.start_date[0] == null || item.start_date[0] > element.start_date[0]) {
                                item.start_date[0] = element.start_date[0]
                            }
                            if (item.start_date[1] == null || item.start_date[1] < element.start_date[1]) {
                                item.start_date[1] = element.start_date[1]
                            }
                        }
                    })
                } else {
                    item.disabled = false
                }
            })
        },
        TeamNameToID(str, multiple = false) {
            let a = str.split(/[:,-]/)
            let b = this.team.filter(item => a.indexOf(item.user.name) != -1)
            let c = b.map(item => item.user_id)
            let d = Array.from(new Set(c))
            let ids = multiple ? d : (d.length > 0 ? d[0] : null)
            return ids
        },
        TemplateChange() {
            this.$refs.xTable.setAllTreeExpand(true)
            this.loading = true
                        let data = this.$refs.xTable.getTableData().tableData.filter(item => !item.parentField)
                        this.$http.post('/9api/projects-template/change', { task: data, template_id: this.template_id }).then(rps => {
                                this.loading = false
                if (rps.data.state == 'success') {
                    this.$notify.success({ title: '成功', message: rps.data.body });
                    this.$emit('onSave')
                    this.Close()
                }
            })
        },
        TaskDel(row, rowIndex) {
            row ? this.$refs.xTable.remove(row) : this.$refs.xTable.removeCheckboxRow()
            this.WorkingTimeCount()
        },
        TaskTemplateDown() {
            window.open('/9api/xlsTemplate/任务导入模板.xls')
        },
        CellFormValidator({ row, column }) {
            if (!row.name || !row.type_id || !row.p || !row.now_assign || !row.start_date || !row.working_days) {
                return {
                    backgroundColor: '#ffebee'
                }
            }
        }
    }
}
</script>